/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 17,
    height: 17,
    viewBox: '0 0 17 17',
    data: '<path pid="0" d="M9.35 0h-1.7v7.65H0v1.7h7.65V17h1.7V9.35H17v-1.7H9.35V0z" _fill="#0078D2"/>'
  }
})
